// User IDs whitelisted to see the Admin → Error Management diagnostic screen.
// Mirrors the legacy single-user gate (profile.id === 3284) in
// mortgageboss_web Settings.js — this is an internal diagnostic page, not a
// production feature. Kept as a set to match the sibling signalrAccess.ts shape.
export const ERROR_MANAGEMENT_USER_IDS: ReadonlySet<number> = new Set([3284])
